import type { EmbedPage } from "@/features/supabase";
import { useGetEmbedPagesQuery } from "@/store/services/supabase";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Empty, Modal, Row, Skeleton } from "antd";
import { sortDatasets } from "../functions";
import { DatasetCard } from "./DatasetCard";
interface DatasetSelectModalProps {
  open: boolean;
  selectedDataset?: EmbedPage;
  onClose: () => void;
  onSelect: (dataset: EmbedPage) => void;
}
export const DatasetSelectModal = ({
  open,
  selectedDataset,
  onClose,
  onSelect
}: DatasetSelectModalProps) => {
  const {
    data: datasets = [],
    isLoading
  } = useGetEmbedPagesQuery();
  const sortedDatasets = sortDatasets(datasets);
  return <Modal title="Select Dataset" open={open} onCancel={onClose} width={880} footer={<div className="mt-2 flex items-start gap-2 rounded-lg bg-subtle p-3 text-left text-sm text-gray-500">
          <InfoCircleOutlined className="mt-0.5 shrink-0" />
          <span>
            Contact your Customer Success Manager to request access to any locked datasets, or to discuss unlisted
            datasets.
          </span>
        </div>} data-sentry-element="Modal" data-sentry-component="DatasetSelectModal" data-sentry-source-file="DatasetSelectModal.tsx">
      {isLoading ? <Skeleton active paragraph={{
      rows: 6
    }} /> : sortedDatasets.length ? <Row gutter={[16, 16]} className="max-h-[60vh] overflow-y-auto pt-1 pb-2">
          {sortedDatasets.map(dataset => <Col key={dataset.id} md={12} span={24}>
              <DatasetCard dataset={dataset} isSelected={dataset.id === selectedDataset?.id} onSelect={onSelect} />
            </Col>)}
        </Row> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No datasets are available to your organisation." />}
    </Modal>;
};